/** The lead's address on an email: a reply comes from the lead, a send goes to them. */
export const emailLeadAddress = (
  direction: string | null | undefined,
  fromAddress: string | null | undefined,
  toAddress: string | null | undefined
): string | null =>
  ((direction || '').toLowerCase() === 'inbound' ? fromAddress : toAddress) || null;
